var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "12px",
    viewBox: "0 0 15 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pay3",
    transform: "translate(-824.000000, -122.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(583.000000, 113.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blocks-/-Desktop-/-Frame-/-Stepper-/-Desktop-pos-/-Future-step-Copy",
    transform: "translate(147.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Number",
    transform: "translate(86.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tick",
    transform: "translate(6.000000, 5.532992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,4 L5,9 L16,9 L16,11 L3,11 L3,4 L5,4 Z",
    id: "Icon-colour",
    transform: "translate(9.500000, 7.500000) rotate(-45.000000) translate(-9.500000, -7.500000) "
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.d5e11cb2bcf571fcf62327b444387f3b.svg";
export { ForwardRef as ReactComponent };